<template>
  <div>
    <brand-link
        v-if="inEditorMode === true"
    :href="mobile ? setting('footer-link-mobile') : setting('footer-link')"
    :locked="resizing"
  >
    <vue-draggable-resizable
      class="resizable-footer"
      :z="10"
      :draggable="false"
      :handles="['tm']"
      :h="
        mobile
          ? 1*setting('footer-height-mobile', defaultFooterHeight)
          : 1*setting('footer-height', defaultFooterHeight)
      "
      :style="resizableFooterStyle"
      :prevent-deactivation="true"
      :active="true"
      @resizing="onFooterResizing"
      @resizestop="onResizeStop"
    >
      <div slot="tm" style="height: 20px; display: block;"/>
      <footer id="brandfooter" :style="footerStyle">
        <vue-draggable-resizable
          v-if="hasImage('footer-logo')"
          :draggable="false"
          :handles="['bm']"
          :h="
            mobile
              ? 1*setting('footer-logo-height-mobile', 100)
              : 1*setting('footer-logo-height', 50)
          "
          :style="resizableLogoStyle"
          :prevent-deactivation="true"
          :active="true"
          @resizing="onFooterLogoResizing"
          @resizestop="onResizeStop"
        >
          <div slot="bm" style="height: 20px; display: block;"/>
          <brand-logo :src="image('footer-logo')" />
        </vue-draggable-resizable>
      </footer>
    </vue-draggable-resizable>
  </brand-link>
    <slot v-else/>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import VueDraggableResizable from 'vue-draggable-resizable';
import alignmentMixin from './alignment-mixin';
import mobileMixin from './mobile-mixin';
import BrandLink from './BrandLink';
import BrandLogo from './BrandLogo';
import defaults from './defaults';

export default {
  components: {
    VueDraggableResizable,
    BrandLink,
    BrandLogo
  },
  mixins: [alignmentMixin, mobileMixin],
  props: {
    link: {
      type: String,
      default: null
    },
    accountName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      resizing: false
    };
  },
  computed: {
    ...mapGetters('theme', ['hasImage', 'image', 'setting', 'inEditorMode']),
    resizableFooterStyle() {
      return {
        width: '100%',
        position: 'relative',
        transform: 'translate(0px, 0px) !important'
      };
    },
    resizableLogoStyle() {
      return {
        width: 'auto'
      };
    },
    backgroundColor() {
      return this.mobile ? this.setting('brand-footer-background-mobile') : this.setting('brand-footer-background');
    },
    backgroundImage() {
      return this.mobile ? this.image('footer-background-image-mobile') : this.image('footer-background-image');
    },
    logoAlignment() {
      return this.alignment(this.mobile ? this.setting('footer-logo-horizontal-alignment-mobile') : this.setting('footer-logo-horizontal-alignment'));
    },
    footerStyle() {
      return {
        justifyContent: this.logoAlignment,
        backgroundImage: this.backgroundImage === null ? 'none' : `url(${this.backgroundImage})`,
        backgroundColor: this.backgroundColor === null ? 'transparent' : this.backgroundColor
      };
    },
    defaultFooterHeight() {
      return defaults.FOOTER_HEIGHT;
    }
  },
  methods: {
    ...mapMutations('theme', ['updateTheme']),
    onFooterResizing(left, top, width, height) {
      if(this.inEditorMode !== true) return
      this.resizing = true;

      if (this.mobile) {
        this.updateTheme({ 'footer-height-mobile': height });
      } else {
        this.updateTheme({ 'footer-height': height });
      }
    },
    onFooterLogoResizing(left, top, width, height) {
      if(this.inEditorMode !== true) return
      this.resizing = true;

      if (this.mobile) {
        this.updateTheme({ 'footer-logo-height-mobile': height });
      } else {
        this.updateTheme({ 'footer-logo-height': height });
      }
    },
    onResizeStop() {
      if(this.inEditorMode !== true) return
      setTimeout(() => (this.resizing = false), 100);
    }
  }
};
</script>

<style scoped>
#brandfooter {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: none;
  display: flex;
  align-items: center;
}

#brandfooter .brand-logo {
  width: auto;
  height: 100%;
  margin: 0 30px;
}
</style>
